import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { ContractFieldsProps } from 'modules/contracts_settings/components/ContractFields/types'
import ModalOptions from './ModalOptions'

type Props = {
  fieldName: string
  options?: ContractFieldsProps[]
  onAddOption: () => void
  onClose: () => void
  handleInputChange: (index: number, value: string) => void
  onArchiveOption: (index: number) => void
  onDeleteOption: (index: number) => void
  onSubmit: () => void
  submitting?: boolean
}

const EditFieldModal = ({
  fieldName,
  options,
  onClose,
  onAddOption,
  handleInputChange,
  onArchiveOption,
  onDeleteOption,
  onSubmit,
  submitting,
}: Props) => {
  return (
    <Modal
      title={i18n.t('company_settings.general.employment_data.contract_taxonomies.modal.title')}
      description={i18n.t(
        'company_settings.general.employment_data.contract_taxonomies.modal.description'
      )}
      illustration="input-field"
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={() => onClose()}>
            {i18n.t('settings.api_keys.new.cancel')}
          </Button>
          <Button type="primary" submit disabled={submitting}>
            {i18n.t('settings.legal_entities.legal_entity.contracts.modal.edit_fields.submit')}
          </Button>
        </>
      }
      onSubmit={onSubmit}
    >
      <Box flexDirection="column" gap="s24">
        <TextField label="Field title" value={fieldName} readonly />
        <ModalOptions
          options={options}
          onAddOption={onAddOption}
          handleInputChange={handleInputChange}
          onArchiveOption={onArchiveOption}
          onDeleteOption={onDeleteOption}
        />
      </Box>
    </Modal>
  )
}

export default EditFieldModal
